<template>
  <div class="wrapper">
    <public-title phone="手机号" state="状态" @gotobtn="eventbtn" @gotoinquire="eventinquire" :isbtn="true" btnname="批量审批"
      icon="el-icon-sunny">
    </public-title>
    <div class="content">
      <el-table :data="tabledata" style="width: 100%" @selection-change="handleSelectionChange" >
        <!-- 多选栏  批量审批-->
        <el-table-column align="center" type="selection" disabled='true' :selectable='checkboxT' width="55">
        </el-table-column>
        <el-table-column prop="nickname" label="用户昵称" width="180" align="center">
        </el-table-column>
        <el-table-column prop="phone" label="手机号" width="120" align="center">
        </el-table-column>
<!--         <el-table-column prop="username" label="账号" align="center">
        </el-table-column> -->

        <el-table-column prop="province" label="省" align="center">
        </el-table-column>
        <el-table-column prop="city" label="市" align="center">
        </el-table-column>
        <el-table-column prop="area" label="区" align="center">
        </el-table-column>
        <el-table-column width="120" label="生日" align="center">
          <template slot-scope="scope">
            {{scope.row.birthday.split(' ')[0]}}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" align="center">
        </el-table-column>
        <el-table-column width="120" label="状态" align="center">
          <template slot-scope="scope">
            {{FapplyStatus(scope.row.applyStatus)}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handlePass(scope.$index, scope.row)"
              :disabled="scope.row.applyStatus==0?false:true">通过</el-button>
            <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="handleReject(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              title="您确定要驳回这一条记录吗？"> -->
              <el-button slot="reference" size="mini" :disabled="scope.row.applyStatus==0?false:true" @click="handleReject(scope.$index, scope.row)">驳回</el-button>
            <!-- </el-popconfirm> -->
            <!-- <el-popconfirm icon="el-icon-info" v-model="DelVisible" confirmButtonText='确定' cancelButtonText='取消'
              @onConfirm="handleDelete(scope.$index, scope.row)" iconColor="red" style="margin-left: 10px;"
              title="您确定要删除这一条记录吗？"> -->
              <el-button slot="reference" size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            <!-- </el-popconfirm> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[15, 30, 40, 50]" :page-size="100" layout="total, sizes, prev, pager, next, jumper"
        :total="totals">
      </el-pagination>
    </div>
    <el-dialog title="会员审批" :visible.sync="dialogVisible" width="40%">
      <p>会员类型</p>
      <el-radio v-model="typeradio" label="1">试用会员</el-radio>
      <el-radio v-model="typeradio" label="2">正式会员</el-radio>
      <p style="margin-top: 30px;">时间限制</p>
      <el-radio v-for="(item,index) in datearr" :key="index" v-model="vipradio" :label="item.value">{{item.name}}</el-radio>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm()">通过</el-button>
        <el-button type="primary" v-show="!isconfirm" @click="Reject()">驳回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import publicTitle from '../../../components/publicTitle'
  export default {
    components: { publicTitle },
    props: {},
    data() {
      return {
        tabledata: [],
        currentPage: 1,
        pageSize: 15,
        pageIndex: 1,
        totals: 0,
        form: {},
        DelVisible: false,
        dialogVisible: false,
        typeradio: '2', //默认改为正式会员
        vipradio: '4', //默认时间为1年
        id: '', // 会员审批id
        userId: '', // 用户id
        ids: [], // 会员审批ids
        isconfirm: true, // true 为行通过  false 为批量
        datearr:[] //时间限制
      };
    },
    computed: {
      FapplyStatus(val) {
        return (val) => {
          if (val === 0) {
            return '待审核'
          } 
          else if (val === 1) {
            return '通过'
          }
           else if (val === 2) {
            return '驳回'
          }
        }
      }
    },
    mounted() {
      this.updata()
      this.detailslist()
    },
    methods: {
      updata(pageIndex = 1, pageSize = 15, Vphone = '', Vstate = '') {
        this.$http({
          url: this.$api.applylist + `?pageIndex=${pageIndex}&pageSize=${pageSize}&phone=${Vphone}&applyStatus=${Vstate}`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            this.tabledata = res.data.data.records
            this.pageSize = res.data.data.size
            this.currentPage = res.data.data.current
            this.totals = res.data.data.total
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      },
      //时间
      detailslist(){
        this.$http({
          url: this.$api.detailslist + `?type=validityTerm`,
          method: "GET",
        }).then(res => {
          if (res.data.code == 200) {
            // console.log(res.data.data)
            this.datearr = res.data.data;
            // console.log(this.datearr,"this.datearr")
          }else{
            this.$toast("error", res.data.msg);
          }
        })
    },
      eventinquire(form) {
        this.form = form
        this.updata(1, this.pageSize, this.form.Vphone, this.form.Vstate)
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.updata(this.pageIndex, this.pageSize,this.form.Vphone, this.form.Vstate)
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.updata(this.pageIndex, this.pageSize,this.form.Vphone, this.form.Vstate)
      },
      handlePass(index, item) {
        this.dialogVisible = true;
        this.id = item.id
        this.isconfirm = true //行通过
        this.userId = item.userId
      },
      eventbtn() {
        if (this.ids.length <= 0) {
          this.$toast("warning", '请勾选需要批量审批的数据');
        } else {
          this.dialogVisible = true;
          this.isconfirm = false //批量通过
        }
      },
      //驳回
      handleReject(index, item) {
        this.$confirm("您确定要驳回这一条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let createUid = JSON.parse(sessionStorage.getItem("userinfo")).id
        let data = {
          id: item.id,
          createUid: createUid //不改
        }
        this.$http({
          url: this.$api.applyreject,
          method: "PUT",
          data
        }).then(res => {
          console.log(res.data)
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(this.pageIndex, this.pageSize, this.form.Vphone, this.form.Vstate)
          }else{
            this.$toast("error", res.data.msg);
          }
        });
      })
        
      },
      //删除
      handleDelete(index, item) {
         this.$confirm("您确定要删除这一条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$http({
          url: this.$api.applydel + `${item.id}`,
          method: "DELETE",
        }).then(res => {
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(1, this.pageSize, this.form.Vphone, this.form.Vstate)
          }else{
            this.$toast("error", res.data.msg);
          }
          this.DelVisible = false
        });
      })
        
      },
      //行通过 批量通过
      confirm() {
        let createUid = JSON.parse(sessionStorage.getItem("userinfo")).id
        if (this.isconfirm) {
          let data = {
            createUid, //不改
            id: this.id,
            membershipType: this.typeradio,
            userId: this.userId,
            validityTerm: this.vipradio
          }
          console.log(data)
          this.$http({
            url: this.$api.applyadopt,
            method: "PUT",
            data
          }).then(res => {
            console.log(res.data)
            if (res.data.code == 200) {
              this.$toast("success", res.data.msg);
              this.updata(this.pageIndex, this.pageSize, this.form.Vphone, this.form.Vstate)
            }else{
            this.$toast("error", res.data.msg);
          }
          });
          this.dialogVisible = false
        } else {
          let data = {
            ids: this.ids,
            membershipType: this.typeradio,
            validityTerm: this.vipradio,
            applyStatus: 1,
            createUid //不改
          }
          console.log('通过', data)
          this.$http({
            url: this.$api.applybatch,
            method: "PUT",
            data
          }).then(res => {
            console.log(res.data)
            if (res.data.code == 200) {
              this.$toast("success", res.data.msg);
              this.updata(this.pageIndex, this.pageSize, this.form.Vphone, this.form.Vstate)
            }else{
            this.$toast("error", res.data.msg);
          }
          });
          this.dialogVisible = false
        }
      },
      Reject() {
        let createUid = JSON.parse(sessionStorage.getItem("userinfo")).id
        let data = {
          ids: this.ids,
          membershipType: this.typeradio,
          validityTerm: this.vipradio,
          applyStatus: 2,
          createUid //不改
        }
        console.log('驳回', data)
        this.$http({
          url: this.$api.applybatch,
          method: "PUT",
          data
        }).then(res => {
          console.log(res.data)
          if (res.data.code == 200) {
            this.$toast("success", res.data.msg);
            this.updata(this.pageIndex, this.pageSize, this.form.Vphone, this.form.Vstate)
          }else{
            this.$toast("error", res.data.msg);
          }
        });
        this.dialogVisible = false
      },
      checkboxT(row, index) {
        if (row.applyStatus == 0) {
          return 1;
        } else {
          return 0;
        }
      },
      handleSelectionChange(val) {
        this.ids = []
        val.forEach((item) => {
          this.ids.push(item.id)
        })
      },
    },
    created() { },
    beforeDestroy() { }
  };
</script>

<style lang="scss" scoped>
  .role-select {
    width: 290px !important;
  }

  .content { //内容的滚动条
    background: #fff;
    width: 100%;
    height: 100%;
    margin-bottom: 7%;
  }

  /deep/.el-pagination {
    text-align: center;
    padding-bottom: 10px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
/deep/.el-table{
      overflow-x: scroll;
}
    .wrapper{
    height: 100%;
    // overflow: auto;

  }
  /deep/.el-table::before{
  background-color: none;
  opacity:0;
}
/deep/.el-table__body-wrapper{
    height:65vh;
    overflow-y: auto;
}
/deep/.el-table th>.cell{
  color: #000;
}
</style>